import type { RouteTableRowData } from '../types/routeTable';

export function getRouteTableRowField(
  row: RouteTableRowData,
  field: string
): unknown {
  const record = row as unknown as Record<string, unknown>;
  return record[field];
}
